import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, ViewChildren, QueryList, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Product } from './interfaces/products.interface';
import { AuthService } from '../../../../core/service/auth.service';
import { ProductModalService } from '../../../../core/service/product-modal.service';
import { ProductService } from './service/product.service';
import { Subscription } from 'rxjs';
import { ProductData } from '../list-products/interfaces/list-products-new.interface';
import { gsap } from 'gsap';

@Component({
  selector: 'establishment-main-products',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './products.component.html',
  styleUrl: './products.component.css'
})

export class ProductsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isOpen: boolean = false;
  @Input() set products(value: ProductData[]) {
    if (value && value.length > 0) {
      this._allProducts = value;
      this.productService.initProducts(value);
    }
  }

  get products(): ProductData[] {
    return this._visibleProducts;
  }

  @ViewChild('loadingTrigger') loadingTrigger!: ElementRef;
  @ViewChildren('productCard', { read: ElementRef }) productCards!: QueryList<ElementRef<HTMLElement>>;

  private _allProducts: ProductData[] = [];
  private _visibleProducts: ProductData[] = [];
  private subscription: Subscription = new Subscription();

  isLoggedIn: boolean = false;
  isLoading: boolean = true;
  readonly defaultImage = 'assets/imagen_default.png';
  skeletonArray = Array(6).fill(0); // Para mostrar 6 skeletons mientras carga
  constructor(
    private authService: AuthService,
    // private establishService: EstablishmentIsOpenService,
    private productModalService: ProductModalService,
    private productService: ProductService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Check if user is logged in
    this.isLoggedIn = this.authService.isLoggedIn();

    // Subscribe to auth changes
    this.subscription.add(
      this.authService.getCurrentUser().subscribe(user => {
        this.isLoggedIn = !!user;
      })
    );

    // Subscribe to visible products
    this.subscription.add(
      this.productService.getVisibleProducts().subscribe(products => {
        this._visibleProducts = products;
        this.isLoading = products.length === 0;
        this.cd.detectChanges();
        // Animar tarjetas cuando cambian los productos visibles (p.ej. al filtrar)
        setTimeout(() => this.animateCards(), 0);
      })
    );
  }

  ngAfterViewInit(): void {
    // Configurar el observador de intersección después de que la vista se haya inicializado
    if (this.loadingTrigger) {
      setTimeout(() => {
        this.productService.setupIntersectionObserver(this.loadingTrigger.nativeElement);
      }, 100);
    }

    // Animar cuando cambie el QueryList (cuando Angular actualiza la vista)
    if (this.productCards) {
      this.productCards.changes.subscribe(() => {
        this.animateCards();
      });
    }
  }

  ngOnDestroy(): void {
    // Limpiar suscripciones y desconectar el observador
    this.subscription.unsubscribe();
    this.productService.disconnect();
  }

  openProductModal(product: Product | ProductData) {
    // console.log('hola presionaste el boton de agregar');

    this.productModalService.openModal(product);
  }

  

  private animateCards(): void {
    if (!this.productCards || this.productCards.length === 0) {
      return;
    }
    const elements = this.productCards.map(ref => ref.nativeElement);
    // Evitar conflictos de animaciones anteriores
    gsap.killTweensOf(elements);
    // Asegurar estado visible final
    gsap.fromTo(
      elements,
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: 0.35, stagger: 0.05, ease: 'power2.out' }
    );
  }
  onImageError(event: any): void {
    event.target.src = this.defaultImage;
  }

  onAddToCart(addBtn: HTMLElement, cartIcon: HTMLElement, product: Product | ProductData) {
    if (!this.isOpen) return;

    const tl = gsap.timeline({ defaults: { ease: 'power1.out' } });
    tl.to(addBtn, { scale: 1.06, duration: 0.15 })
      .to(addBtn, { scale: 1, duration: 0.15 })
      .to(cartIcon, { y: -2, rotation: 15, duration: 0.15 }, '<')
      .to(cartIcon, { y: 0, rotation: -15, duration: 0.15 })
      .to(cartIcon, { rotation: 0, duration: 0.1 });

    tl.eventCallback('onComplete', () => {
      this.openProductModal(product);
    });
  }

  // isAvailable(product: ProductData): boolean {
  //   // If product doesn't have opening/closing times, it's not available
  //   if (!product. || !product.cierre) {
  //     return false;
  //   }
  //   // If product is marked as closed (isOpen="0"), it's not available
  //   if (product.isOpen === "0") {
  //     return false;
  //   }
  //   // Check if current time is within operating hours
  //   return this.establishService.isEstablishmentOpen(product.apertura, product.cierre, product.isOpen);
  // }
}
